import React, {useState} from 'react';
import {Button, Grid, TextField, InputLabel, IconButton, Backdrop, CircularProgress} from '@mui/material';
import {APP_RESET_PASSWORD_API} from '../../../constants/api_urls';
import axios from 'axios';
import ReactPasswordChecklist from 'react-password-checklist';
import './NewPassword.scss'
import { useParams } from 'react-router-dom';
import { Visibility, VisibilityOff } from '@mui/icons-material';
import { useSnackbar } from 'notistack';

const NewPasswordForm = ({setPasswordUpdating, email}) => {
    const [newPassword, setNewPassword] = useState('');
    const [confirm_password, setConfirmPassword] = useState('');
    const [isValid,setIsValid] = useState(false)
    const [errorMessage, setErrorMessage] = useState("")
    const {token} = useParams();
    const [showPassword,setShowPassword] = useState(false)
    const [showConfirmPassword,setShowConfirmPassword] = useState(false)
    const [isLoading, setIsLoading] = useState(false);
    const {enqueueSnackbar} = useSnackbar()


    const handleSubmit = async (event) => {
        event.preventDefault();

        try {
          setIsLoading(true);
            const response = await axios.post(`${APP_RESET_PASSWORD_API}`, {
                password: newPassword,
                confirm_password,
                token
            });


            if (response?.data) {
                setIsLoading(false);
                setPasswordUpdating('Your password has been successfully changed');
                sessionStorage.removeItem("token")

                //alert('Password updated successfully');
            } else {
                setIsLoading(false);
                throw new Error('Password update failed');
            }
        } catch (error) {
            setIsLoading(false);
            if (error?.response?.data?.error_message) {
                // setErrorMessage(error?.response?.data?.error_message)
                enqueueSnackbar({
                  message: error?.response?.data?.error_message,
                  variant: "error",
                  anchorOrigin: {
                    vertical: "bottom",
                    horizontal: "left"
                  }
                })
            }
            console.error('Error:', error);
            // Handle error
        }
    };

    return (
        <form onSubmit={handleSubmit}>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              {" "}
              {/* Full width for Password */}
              <InputLabel htmlFor="new password" shrink>
                New Password
              </InputLabel>
              <TextField
                id="newpassword"
                type={showPassword ? "text" : "password"}
                variant="outlined"
                required
                value={newPassword}
                onChange={(e) => {
                  setErrorMessage("");
                  setNewPassword(e.target.value);
                }}
                disabled={isLoading}
                InputProps={{
                  sx: {
                    height: "30px", // Set fixed height
                    width: "298px",
                    paddingRight: "0px",
                    marginTop: 0,
                  },
                  endAdornment: (
                    <IconButton
                      onClick={() => {
                        setShowPassword((prev) => !prev);
                      }}
                    >
                      {showPassword ? (
                        <VisibilityOff
                          sx={{
                            fontSize: "18px",
                          }}
                        />
                      ) : (
                        <Visibility
                          sx={{
                            fontSize: "18px",
                          }}
                        />
                      )}
                    </IconButton>
                  ),
                }}
                InputLabelProps={{
                  shrink: true, // Keep label in place
                  sx: {
                    marginTop: 0, // Remove top margin
                  },
                }}
              />
            </Grid>
            <Grid item xs={12}>
              {" "}
              {/* Full width for Password */}
              <InputLabel htmlFor="confirm password" shrink>
                Confirm Password
              </InputLabel>
              <TextField
              disabled={isLoading}
                id="confirm_password"
                type={showConfirmPassword ? "text" : "password"}
                variant="outlined"
                required
                value={confirm_password}
                onChange={(e) => {
                  setErrorMessage("");
                  setConfirmPassword(e.target.value);
                }}
                InputProps={{
                  sx: {
                    height: "30px", // Set fixed height
                    marginTop: 0, // Remove top margin
                    width: "298px",
                    padding: "0px",
                  },
                  endAdornment: (
                    <IconButton
                      onClick={() => {
                        setShowConfirmPassword((prev) => !prev);
                      }}
                    >
                      {showConfirmPassword ? (
                        <VisibilityOff
                          sx={{
                            fontSize: "18px",
                          }}
                        />
                      ) : (
                        <Visibility
                          sx={{
                            fontSize: "18px",
                          }}
                        />
                      )}
                    </IconButton>
                  ),
                }}
                InputLabelProps={{
                  shrink: true, // Keep label in place
                  sx: {
                    marginTop: 0, // Remove top margin
                  },
                }}
              />
            </Grid>
            <ReactPasswordChecklist
              className="password-error-container"
              itemClassName="item-styles"
              iconSize={12}
              rules={["minLength", "specialChar", "number", "capital", "match"]}
              minLength={12}
              value={newPassword}
              valueAgain={confirm_password}
              onChange={(val) => {
                setIsValid(val);
              }}
            />
          </Grid>
          {errorMessage && (
            <div style={{ color: "red" }}>{errorMessage || ""}</div>
          )}
          <Grid>
            <Grid item xs={12}>
              <Button
                type="submit"
                variant="contained"
                color="success"
                fullWidth
                sx={{
                  width: "100px",
                  height: "44px",
                  flexShrink: "0",
                  borderRadius: "10px",
                  background: "#61D5A9",
                  marginTop: "35px",
                }}
                disabled={!isValid || isLoading}
              >
                Save {isLoading && <CircularProgress size={16} sx={{marginLeft: "8px"}}/>}
              </Button>
            </Grid>
          </Grid>
        </form>
    );
};

export default NewPasswordForm;
